/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuMultiSelectSearch_viewer$ref = any;
export type SbSharedRefineMenuFilterMaterial_viewer$ref = any;
export type SbSharedRefineMenuFilterMaterial_viewer = {
    readonly " $fragmentRefs": SbSharedRefineMenuMultiSelectSearch_viewer$ref;
    readonly " $refType": SbSharedRefineMenuFilterMaterial_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterMaterial_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'f1ee0f61f00d2c93120f509f2ef54cde';
export default node;
